'use strict';

/* Container
 * 컨테이너들을 상속하는 클래스 */
class Container {
    constructor() {

    }
}

export default Container;



//////////////////
// WEBPACK FOOTER
// ./js/lib/Container.js
// module id = 402
// module chunks = 0